import React, {FC} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {CheckBox} from '../../../../../../../libs/shared/ui/src/components/booleanInputs/checkBox';
import {fontSizes} from '../../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface SettingsDevelopersChannelBooleanInputProps {
  className?: string;
  isChecked: boolean;
  title: React.ReactNode;
  description: React.ReactNode;
  onChange: HandlerOf<boolean>;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  display: flex;
  flex-flow: row;
  gap: 8px;
`;

const StyledDetailsWrapperDiv = styled.div`
  display: flex;
  flex-flow: column;
  gap: 4px;
  line-height: 16px;
`;

const StyledDetailsDescriptionDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.verySmall};
`;

const StyledCheckBoxWrapperDiv = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const StyledCheckBox = styled(CheckBox)`
  height: 16px;
`;

/*
 * Component.
 */

export const SettingsDevelopersChannelBooleanInput: FC<SettingsDevelopersChannelBooleanInputProps> = (
  props,
) => {
  const {className, isChecked, title, description, onChange} = props;
  return (
    <StyledWrapperDiv
      className={className}
      onClick={(event) => {
        if (event.defaultPrevented) {
          return;
        }
        onChange(!isChecked);
      }}
    >
      <StyledCheckBoxWrapperDiv>
        <StyledCheckBox isChecked={isChecked} onChange={onChange} />
      </StyledCheckBoxWrapperDiv>
      <StyledDetailsWrapperDiv>
        {title}
        <StyledDetailsDescriptionDiv>{description}</StyledDetailsDescriptionDiv>
      </StyledDetailsWrapperDiv>
    </StyledWrapperDiv>
  );
};
